import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import withState from 'recompose/withState';
import ChangeGochiKidFlagShopDialogAdmin from '../molecules/ChangeGochiKidFlagShopDialogAdmin';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(withState('openChange', 'updateOpenChange', false));

const button = enhance(
  ({
    disabled,
    textButton,
    openChange,
    updateOpenChange,
    gochiKidFlag,
    gochiKidDonateFlag,
    gochiKidUserUseType,
    gochiKidQrFlag,
    searchKey,
    shopId
  }) => {
    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateOpenChange(true)}
        >
          {textButton}
        </Button>
        <ChangeGochiKidFlagShopDialogAdmin
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          oldGochiKidFlag={gochiKidFlag}
          oldGochiKidDonateFlag={gochiKidDonateFlag}
          oldGochiKidUserUseType={gochiKidUserUseType}
          oldGochiKidQrFlag={gochiKidQrFlag}
          shopId={shopId}
          searchKey={searchKey}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
